import React from 'react';
import Header from '../components/Header/Header';
import Hero from '../components/Hero/Hero';
import Features from '../components/Features/Features';
import TransferForm from '../components/TransferForm/TransferForm';
import Footer from '../components/Footer/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen flex flex-col Aleo">
      <Header />
      <main className="flex-grow">
        <Hero />
        <Features />
        <TransferForm />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
